import { ThemeConfig, theme } from 'antd';
import { AgencyTheme } from '../constants/enums/agencyTheme';

const { darkAlgorithm } = theme;

export const isDarkTheme = (): boolean => {
  const themeNumber = +(window as any).REACT_APP_THEME as AgencyTheme;

  if (Number.isNaN(themeNumber)) {
    return false;
  }

  switch (themeNumber) {
    case AgencyTheme.Dark:
    case AgencyTheme.Night:
      return true;
    default:
      return false;
  }
};

export const getThemeToken = () => {
  const themeNumber = +(window as any).REACT_APP_THEME as AgencyTheme;

  if (Number.isNaN(themeNumber)) {
    throw new Error('window.REACT_APP_THEME value must be provided.');
  }

  let colorPrimary: string = '';
  let colorBgContainer: string = '';

  switch (themeNumber) {
    case AgencyTheme.Primary:
      colorPrimary = '#279CB3';
      colorBgContainer = '#fff';
      break;
    case AgencyTheme.Secondary:
      colorPrimary = '#A80014';
      colorBgContainer = '#fff';
      break;
    case AgencyTheme.Third:
      colorPrimary = '#14806A';
      colorBgContainer = '#fff';
      break;
    case AgencyTheme.Dark:
      colorPrimary = '#279CB3';
      colorBgContainer = '#21282f';
      break;
    case AgencyTheme.Indigo:
      colorPrimary = '#693eb5';
      colorBgContainer = '#fff';
      break;
    case AgencyTheme.Ocean:
      colorPrimary = '#1287DE';
      colorBgContainer = '#fff';
      break;
    case AgencyTheme.Night:
      colorPrimary = '#3D7681';
      colorBgContainer = '#21282f';
      break;
    case AgencyTheme.Platinum:
      colorPrimary = '#279CB3';
      colorBgContainer = '#fff';
      break;
    case AgencyTheme.Iron:
      colorPrimary = '#279CB3';
      colorBgContainer = '#fff';
      break;
    case AgencyTheme.Ukraine:
      colorPrimary = '#1287DE';
      colorBgContainer = '#fff';
      break;
    case AgencyTheme.BTIS:
      colorPrimary = '#3A2968';
      colorBgContainer = '#fff';
      break;
  }

  const themeToken: ThemeConfig = {
    algorithm: isDarkTheme() ? [darkAlgorithm] : [],
    token: {
      colorPrimary: colorPrimary,
      colorBgContainer: colorBgContainer,
      borderRadius: 2,
    },
  };

  return themeToken;
};
